export const ALPHANUMERIC_PATTERN = /^[_a-zA-Z0-9]+$/;
export const ALPHANUMERIC_VALIDATION_MESSAGE = 'Only alphanumeric characters and _ are allowed';

export default function alphanumeric(value) {
  return ALPHANUMERIC_PATTERN.test(value) || ALPHANUMERIC_VALIDATION_MESSAGE;
}
